import Error from './Error';

export default class ExpiredTokenError extends Error {

}